import React from "react";
import { TypeAnimation } from "react-type-animation";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import Layout from "../../../components/layout/Layout";
import { useOffer } from "../../../utils/Contexts/V2/OfferContext";

function OfferTextOption({ title, message, selectOptionHandler }) {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col justify-start items-start w-full lg:w-[22vw] mb-2 border-[1px] border-[#E7E7E7] rounded-[0.75rem] p-[0.75rem] space-y-[0.75rem] overflow-hidden">
      <div>
        <p className="text-black font-semibold text-[0.675rem]">Title:</p>
        <TypeAnimation
          sequence={title}
          className="text-black font-normal italic text-[0.875rem]"
          speed={70}
          wrapper="p"
          repeat={0}
          cursor={false}
        />
      </div>
      <div>
        <p className="text-black font-semibold text-[0.675rem]">Message:</p>
        <TypeAnimation
          sequence={message}
          className="text-black font-normal italic text-[0.875rem] leading-loose"
          speed={70}
          wrapper="p"
          repeat={0}
          cursor={false}
        />
      </div>
      <button
        type="button"
        className="w-fit p-2 text-[0.875rem] font-semibold text-white bg-primary-50 rounded-[0.5rem] self-end"
        onClick={() => selectOptionHandler(title, message, navigate)}
      >
        Select this
      </button>
    </div>
  );
}

OfferTextOption.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  selectOptionHandler: PropTypes.func.isRequired,
};

export default function OfferTextOptions() {
  const { textOptions, selectTextOptionHandler } = useOffer();

  return (
    <Layout headerTitle="Choose a Text Marketing Message" header>
      <div className="relative w-full md:max-w-screen-lg h-screen scroll-smooth pt-20 flex flex-col items-center justify-between">
        <div className="px-4 flex flex-col justify-center items-center space-y-12">
          <p className="px-7 font-normal text-base font-sm text-center">
            Select a ready-to-send Text Marketing Message that fits your
            campaign goals.
          </p>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 lg:gap-4 mx-auto w-full">
            {textOptions.map((option) => (
              <OfferTextOption
                title={option.title}
                message={option.offer}
                selectOptionHandler={selectTextOptionHandler}
              />
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
}
